import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useFormContext, useWatch } from 'react-hook-form';
import CustomCheckbox from '../../../../../../generic/CustomCheckbox';
import CustomTextarea from '../../../../../../generic/CustomTextarea';
import Tooltip from '../../../../../../components/Tooltip';
import { ReactComponent as TooltipIcon } from '../../../../../../assets/image/carbon/circle-exclamation.svg';
import './LegalAndFinancial.scss';
import NotificationAlert from '../../../../../../generic/NotificationAlert';

const LegalAndFinancial = ({ defaultValues, tabKey, isActiveTab, disabled }) => {
  const translate = useIntl();
  const { register, errors } = useFormContext();
  const { [tabKey]: formErrors } = errors;

  const isTrueString = (s) => s === 'true';
  const [statusAlert, setStatusAlert] = useState({ enoughFundingToProtect: false, viableWithoutCarbonFinancing: false });
  const changeStatusAlert = (type, value) => {
    if (type === 'howOFPHelps') {
      const isWarning = value.length < 5;
      return setStatusAlert({ ...statusAlert, [type]: isWarning });
    }
    const isWarning = value.length < 150;

    setStatusAlert({ ...statusAlert, [type]: isWarning });
  };
  const watchEnvImpactAssessment = useWatch({ name: `${tabKey}.envImpactAssessment`, exact: true });
  const watchAreActivitiesLegalRequirement = useWatch({ name: `${tabKey}.areActivitiesLegalRequirement`, exact: true });
  const watchIsTimberHarvestingPlanned = useWatch({ name: `${tabKey}.isTimberHarvestingPlanned`, exact: true });

  return (
    <div className="legal-financial__wrapper" style={{ display: isActiveTab ? 'block' : 'none' }}>
      <div className="legal-financial">
        <div className="legal-financial__item">
          <div>
            <p className="form-field-title">{translate.formatMessage({ id: 'carbon.form.needGovernmentApprove' })}</p>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.needGovernmentApprove`}
                defaultChecked={isTrueString(defaultValues.needGovernmentApprove)}
                register={register({ required: true })}
                error={formErrors?.needGovernmentApprove}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.needGovernmentApprove`}
                defaultChecked={isTrueString(defaultValues.needGovernmentApprove)}
                register={register({ required: true })}
                error={formErrors?.needGovernmentApprove}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        <div className="legal-financial__item">
          <div>
            <p className="form-field-title">{translate.formatMessage({ id: 'carbon.form.envImpactAssessment' })}</p>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.envImpactAssessment`}
                defaultChecked={isTrueString(defaultValues.envImpactAssessment)}
                register={register({ required: true })}
                error={formErrors?.envImpactAssessment}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.envImpactAssessment`}
                defaultChecked={isTrueString(defaultValues.envImpactAssessment)}
                register={register({ required: true })}
                error={formErrors?.envImpactAssessment}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.summaryOfImpacts' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.summaryOfImpacts`}
            value={defaultValues.summaryOfImpacts}
            register={register({ required: isTrueString(watchEnvImpactAssessment) })}
            error={formErrors?.summaryOfImpacts}
            disabled={disabled}
          />
        </div>
        <div className="legal-financial__item">
          <div>
            <p className="form-field-title">{translate.formatMessage({ id: 'carbon.form.areActivitiesLegalRequirement' })}</p>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.areActivitiesLegalRequirement`}
                defaultChecked={isTrueString(defaultValues.areActivitiesLegalRequirement)}
                register={register({ required: true })}
                error={formErrors?.areActivitiesLegalRequirement}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.areActivitiesLegalRequirement`}
                defaultChecked={isTrueString(defaultValues.areActivitiesLegalRequirement)}
                register={register({ required: true })}
                error={formErrors?.areActivitiesLegalRequirement}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.activitiesRequirementExplanation' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.activitiesRequirementExplanation`}
            value={defaultValues.activitiesRequirementExplanation}
            register={register({ required: isTrueString(watchAreActivitiesLegalRequirement) })}
            error={formErrors?.activitiesRequirementExplanation}
            disabled={disabled}
          />
        </div>
        <div className="legal-financial__item">
          <div>
            <p className="form-field-title">{translate.formatMessage({ id: 'carbon.form.isTimberHarvestingPlanned' })}</p>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.isTimberHarvestingPlanned`}
                defaultChecked={isTrueString(defaultValues.isTimberHarvestingPlanned)}
                register={register({ required: true })}
                error={formErrors?.isTimberHarvestingPlanned}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.isTimberHarvestingPlanned`}
                defaultChecked={isTrueString(defaultValues.isTimberHarvestingPlanned)}
                register={register({ required: true })}
                error={formErrors?.isTimberHarvestingPlanned}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.timberHarvestingExplanation' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.timberHarvestingExplanation`}
            value={defaultValues.timberHarvestingExplanation}
            register={register({ required: isTrueString(watchIsTimberHarvestingPlanned) })}
            error={formErrors?.timberHarvestingExplanation}
            disabled={disabled}
          />
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.projectFinancing' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.projectFinancing`}
            value={defaultValues.projectFinancing}
            register={register({ required: true })}
            error={formErrors?.projectFinancing}
            disabled={disabled}
          />
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.financingReceived' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea="textarea-field"
            customClassLabel="form-field-title"
            name={`${tabKey}.financingReceived`}
            value={defaultValues.financingReceived}
            register={register({ required: true })}
            error={formErrors?.financingReceived}
            disabled={disabled}
          />
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.enoughFundingToProtect' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea={`textarea-field${statusAlert?.enoughFundingToProtect ? ' warning' : ''}`}
            customClassLabel="form-field-title"
            name={`${tabKey}.enoughFundingToProtect`}
            value={defaultValues.enoughFundingToProtect}
            register={register({ required: true })}
            error={formErrors?.enoughFundingToProtect}
            disabled={disabled}
            change={(e) => {
              changeStatusAlert('enoughFundingToProtect', e.target.value);
            }}
          />
          {statusAlert?.enoughFundingToProtect && <NotificationAlert text={translate.formatMessage({ id: 'carbon.form.enoughFundingToProtect.warning' })} />}
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.viableWithoutCarbonFinancing' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea={`textarea-field${statusAlert?.viableWithoutCarbonFinancing ? ' warning' : ''}`}
            customClassLabel="form-field-title"
            name={`${tabKey}.viableWithoutCarbonFinancing`}
            value={defaultValues.viableWithoutCarbonFinancing}
            register={register({ required: true })}
            error={formErrors?.viableWithoutCarbonFinancing}
            disabled={disabled}
            change={(e) => {
              changeStatusAlert('viableWithoutCarbonFinancing', e.target.value);
            }}
          />
          {statusAlert?.viableWithoutCarbonFinancing && <NotificationAlert text={translate.formatMessage({ id: 'carbon.form.viableWithoutCarbonFinancing.warning' })} />}
        </div>
        <div className="legal-financial__item">
          <div>
            <div className="form-field-title">
              <span>{translate.formatMessage({ id: 'carbon.form.willOFPHelp' })}</span>
              <Tooltip
                wrapperClass="tooltip"
                targetElement={<TooltipIcon data-tip data-iscapture data-for="ofp-help" />}
                tooltipElement={translate.formatMessage({ id: 'carbon.form.willOFPHelpTooltip' })}
                tooltipProps={{ className: 'tooltip__message', id: 'ofp-help' }}
              />
            </div>
            <div>
              <CustomCheckbox
                type="radio"
                value="true"
                title={translate.formatMessage({ id: 'carbon.form.yes' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.willOFPHelp`}
                defaultChecked={isTrueString(defaultValues.willOFPHelp)}
                register={register({ required: true })}
                error={formErrors?.willOFPHelp}
                disabled={disabled}
              />
              <CustomCheckbox
                type="radio"
                value="false"
                title={translate.formatMessage({ id: 'carbon.form.no' })}
                customClass="radio-button-wrapper"
                name={`${tabKey}.willOFPHelp`}
                defaultChecked={isTrueString(defaultValues.willOFPHelp)}
                register={register({ required: true })}
                error={formErrors?.willOFPHelp}
                disabled={disabled}
              />
            </div>
          </div>
        </div>
        <div className="legal-financial__item">
          <CustomTextarea
            label={translate.formatMessage({ id: 'carbon.form.howOFPHelps' })}
            placeholder={translate.formatMessage({ id: 'carbon.placeholder.text' })}
            classTextarea={`textarea-field${statusAlert?.howOFPHelps ? ' warning' : ''}`}
            customClassLabel="form-field-title"
            name={`${tabKey}.howOFPHelps`}
            value={defaultValues.howOFPHelps}
            register={register({ required: true })}
            error={formErrors?.howOFPHelps}
            disabled={disabled}
            change={(e) => {
              changeStatusAlert('howOFPHelps', e.target.value);
            }}
          />
          {statusAlert?.howOFPHelps && <NotificationAlert text={translate.formatMessage({ id: 'carbon.form.howOFPHelps.warning' })} />}
        </div>
      </div>
    </div>
  );
};

export default LegalAndFinancial;
